const theme = {
    colors: {
        primary: "aliceblue",
        secondary: '#C89446',
        dark: "rgb(11, 11, 11)",
        lightDark: "#f0f8ff17"
    },
    fonts: {
        primary: 'Raleway, sans-serif;',
        secondary: 'Pinyon Script, cursive;'
    }
};

export default theme
